<template>
    <section class="travelogue-list row">
        <div class="wrapper">
            <div class="filtres">
                <a class="btn" :class="{ outline: !inProgress }" href="" @click.prevent="goFilter('inProgress')">Les
                    voyages en cours</a>
                <a class="btn" href="" :class="{ outline: inProgress }" @click.prevent="goFilter('past')">Les voyages
                    passés</a>
            </div>
            <div class="wrap-filter-mobile">
                <custom-select
                        class="mobile-filter"
                        valueField="slug"
                        labelField="label"
                        v-model="selectedTravelogueTypeValue"
                        :options="optionsTypeTravelogue"
                        v-on:change="goFilter($event)"
                ></custom-select>
            </div>
            <div class="sub-filters" v-if="!inProgress">
                <div class="one-filter">
                    <p>Destinations</p>
                    <custom-select
                            class="pin"
                            valueField="slug"
                            v-model="selectedDestinationValue"
                            :options="filters.destination"
                            v-on:change="updateDates($event)"
                    ></custom-select>
                </div>
                <div class="one-filter">
                    <p>Année</p>
                    <custom-select
                            class="calendrier"
                            valueField="date"
                            v-model="selectedDateValue"
                            :options="selectedDateOptions"

                    ></custom-select>
                </div>
                <div class="one-filter apply-filters">
                    <a href="" class="btn chevron dir-down" @click="applyFilters">Filtrer</a>
                </div>
            </div>

            <transition-group
                    name="fade"
                    tag="div"
                    class="wrap-articles-card"
                    v-bind:css="false"
                    v-on:before-enter="beforeEnter"
                    v-on:enter="enter"
                    v-on:leave="leave"

            >
                <a v-for="(article, index) in articles"
                   :href="article.url"
                   class="travelogue-card"
                   :key="index"
                   v-if="showArticle(index)"
                   :data-index="index"
                >
                    <article>
                        <div class="header" :style="'background-image: url('+article.imgUrlSmall+')'">
                        </div>
                        <div class="body">
                            <div>
                                <h2>{{article.post_title}}</h2>
                                <p v-html="article.formatedDate" class="date"></p>
                            </div>
                            <span class="lien-inline">Découvrir</span>
                        </div>
                    </article>
                </a>
            </transition-group>
            <div class="clearfix cta" v-if="!reachEnd">
                <a class="btn chevron dir-down outline loadmore"
                   @click="showMore()"
                >Charger plus de carnets de voyage</a>
            </div>
        </div>
    </section>
</template>

<script>
    import $ from 'jquery';
    import Scrolling from '../../libs/Scrolling';

    export default {
        props: {
            articles: {
                type: Array,
                required: true,
            },
            filters: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                ShowLimit: 6,
                showMoreCount: 6,
                offset: null,
                heightCard: 150,


                selectedDateValue: null,
                selectedDestinationValue: this.$route.query.destination ? this.$route.query.destination : this.filters.destination[0].slug,
                selectedDateOptions: null,

                inProgress: this.$route.query.status === 'inProgress',

                selectedTravelogueTypeValue: 'past',
                optionsTypeTravelogue: [
                    {
                        label: 'Les voyages en cours',
                        slug: 'inProgress'
                    },
                    {
                        label: 'Les voyages passés',
                        slug: 'past'
                    }
                ]

            };
        },
        computed: {
            reachEnd() {
                if (this.ShowLimit >= this.articles.length) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        methods: {
            showArticle(index) {
                if (index < this.ShowLimit) {
                    return true;
                }
            },
            showMore() {
                // let anchor = 'a[data-index="' + this.offset + '"]'
                setTimeout(() => {
                    this.offset = this.offset + this.showMoreCount;
                    // Scrolling.scrollTo(anchor, 'easeInOutQuint', 1200, 80)

                }, 100);
                this.ShowLimit = this.ShowLimit + this.showMoreCount;
            },
            beforeEnter: function (el) {
                // el.style.opacity = 0;
                // el.style.height = 0;
                $(el).removeClass('show');
                $(el).addClass('hidden');
            },
            enter: function (el, done) {

/*                var delay = ((el.dataset.index - this.offset) * 150);

                setTimeout(() => {
                    Velocity(
                        el,
                        {opacity: 1, height: this.heightCard + 'px'},
                        {complete: done}
                    );
                }, delay);*/

                var delay = ((el.dataset.index - this.offset) * 150);

                setTimeout(() => {
                    $(el).addClass('show');
                }, delay);

            },
            leave: function (el, done) {
                var delay = el.dataset.index * 150;
                setTimeout(function () {
                    Velocity(
                        el,
                        {opacity: 0, height: 0},
                        {complete: done}
                    );
                }, delay);
            },
            goFilter(value) {
                let query = {};

                if (value === "inProgress") {
                    query.status = 'inProgress';
                }
                if (value === "past") {
                    query.status = 'past';
                }

                this.$router.push({
                    url: this.$route.path,
                    query: query
                });
                this.$router.go();
            },
            updateDates(value) {
                let options = this.filters['destination'].find(option => option['slug'] === value);
                this.selectedDateOptions = options.dates;
                this.selectedDateValue = options.dates[0].date;
            },
            applyFilters() {

                let query = {};

                query.destination = this.selectedDestinationValue;
                query.date = this.selectedDateValue;

                this.$router.push({
                    query: query
                });
            },
        },
        created() {

            this.updateDates(this.selectedDestinationValue);

            if (this.$route.query.date) {
                this.selectedDateValue = this.$route.query.date;
            }
            if (this.$route.query.status) {
                this.selectedTravelogueTypeValue = this.$route.query.status;
            }


        },
        mounted() {
            this.heightCard = $('.travelogue-list article').innerHeight();
            this.offset = this.ShowLimit;

            if (this.$route.query.destination || this.$route.query.date || this.$route.query.status) {
                Scrolling.scrollTo('.travelogue-list', 'easeInOutCubic', 1200, 200);
            }

        },
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/magazine/TravelogueList.vue